import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { PricingFAQ } from "../components/FAQ";
import { useNavigate } from "react-router";
import { LoginCheckerModal } from "../components/Modal";
import data from "../data/data";


export default function Pricing() 
{

  const navigate = useNavigate();

  const plans = data?.pricing || [];

  const info = [
    { title: "Accessibilité des services", desc: "Agrospace rend ses services accessibles non seulement par des tarifs adaptés, mais aussi grâce à une utilisation simple et intuitive, un accès multi-applications via une seule plateforme, et la possibilité de commencer gratuitement avec le modèle Freemium.", icon: "bi bi-wallet2" },
    { title: "Réabonnement et offres spéciales", desc: "Nous valorisons nos utilisateurs fidèles. Le réabonnement à nos services est simple et flexible, et nous proposons régulièrement des offres bonus, des remises ou des fonctionnalités supplémentaires pour rendre l’expérience encore plus avantageuse et enrichissante.", icon: "bi bi-arrow-repeat" },
  ];

  const [ loginChecker , setloginChecker ] = useState(false);
  const closeoginCheckerModal = ( arg ) => {  setloginChecker( arg ) }
  
  const getAccessApp = (url) => {
      setloginChecker(false);
      (localStorage.getItem('token')) ? navigate(url) : setloginChecker(true);      
  }

  return (
    <div className="bg-light min-vh-100">
      { loginChecker && ( <LoginCheckerModal method={ closeoginCheckerModal } message={"Erreur d'acces, Vueillez vous connecter dabord avant toute tentative d'abonnement de nos services premium."} />  )  }
      {/* Header's section */}
      <Header page={3} />

     {/* First section */}
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-6">
            <div className="d-flex flex-column gap-3 text-center pt-5 pb-4">
              <h1 className="display-5 fw-bold"> Agrospace Freemium </h1>
              <p className="text-muted" > Découvrez les fonctionnalités clés de notre plateforme et accédez gratuitement à nos outils essentiels. </p>
            </div>
          </div>
          <div className="col-md-7">
            <div className="d-flex flex-column mb-3 border rounded-2 p-4 shadow-sm bg-green-light">
              <div className="fs-4 text-success me-2">
                <i className="bi bi-bag-check"></i>
              </div>
              <p className="text-muted" >Profitez d’un espace de travail de base pour explorer nos applications et bénéficier de conseils agricoles personnalisés. Commencez à gérer vos exploitations avec efficacité dès aujourd’hui.</p>
            </div>
          </div>   
        </div>    
      </div>

      {/* Pricing section */}
      <div className="container py-5">
        <div className="row g-4">
          { plans.map((plan, idx) => (
          <div className="col-lg-4 col-md-6" key={idx}>
            <div className="card h-100 shadow-sm border p-4  rounded-4">
              <div className="card-body d-flex flex-column">
                <h6 className="fw-bold">{plan.title}</h6>
                <h3 className="fw-bold mb-0">{plan.price} <span className="small text-secondary"> Fcfa </span></h3>
                {plan.price !== "Custom Pricing" && ( <small className="text-muted"> {plan.duration} mois/user</small> )}
                <p className="text-muted small mt-2">{plan.subtitle}</p>

                {plan.extra && ( <p className="small text-muted">{plan.extra}</p> )}

                <button disabled={plan.status} className={`btn btn-${plan.button.variant} mt-2 mb-3`} onClick={ ()=> getAccessApp(`/subscription/${plan.id}`) }>
                  {plan.button.text} <i className="bi bi-arrow-right ms-2"></i>
                </button>

                {plan.note && <p className="small text-muted">{plan.note}</p>}

                <ul className="list-unstyled mt-auto">
                  {plan.features.map((f, i) => (
                    <li key={i} className="d-flex align-items-start mb-2">
                      <p className="d-flex align-items-center gap-2 text-muted mb-1 fw-bold gap-2">
                         <i className="bi bi-check-circle-fill text-success"></i> <span> {f.title} </span>
                      </p>
                      <span className="small text-muted">{f}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
          ))}
        </div>
      </div>


      {/* Popular Pages */}
      <div className="container-fluid bg-green-light py-5 mt-5" >
        <div className="row justify-content-center py-5">
          <div className="col-md-10">
            <div className="d-flex flex-column mb-3">
              <h3 className="" >Des services accessibles et flexibles </h3>
              <p className="text-muted" > Agrospace propose des solutions faciles à utiliser avec des offres spéciales pour récompenser votre fidélité.</p>
            </div>
          </div>
            
          <div className="col-md-10 mt-4"> 
            <div className="row g-4">
              {info.map((item, idx) => (
                <div className="col-md-6" key={idx}>
                  <div className="d-flex flex-column mb-3 border rounded-2 p-4 shadow-sm">
                    <div className="fs-4 text-success me-2">
                      <i className={item.icon}></i>
                    </div>
                    <h4>{item.title}</h4>
                    <p>{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* FAQ section */}
      <PricingFAQ/> 

      {/* Footer's section */}
      <Footer />
      
    </div>
  );
}
